<template>
  <el-dialog title="汇款信息录入" :visible.sync="dialogVisible" width="700px" class="messageInput" :close-on-click-modal="false" @close="close" @open="open">
    上传附件
    <el-upload
      action=""
      multiple
      :show-file-list="false"
      :http-request="uploadaction"
      style="display: inline-block;margin: 10px 10px"
    >
      <el-button :loading="isUploadLoading" type="primary">
        上传文件
      </el-button>
    </el-upload>
    <span class="uploadPrompt">*  您可以先上传文件，自动识别出部分汇款信息，代替手工填写。</span>
    <el-table ref="multipleTable" :data="fileList" border style="width: 100%">
      <el-table-column prop="fileName" label="文件名称" align="left" />
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column label="操作" align="left" fixed="right">
        <template v-slot="{row,index}">
          <el-button type="text" @click="remove(index)">
            删除
          </el-button>
          <el-button type="text" @click="download(row)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-form ref="form" :model="info" :rules="rules" class="baseInfoForm">
      <div class="rj-page-card">
        <div class="rj-page-card__content">
          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇款编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.telegraphicTransferNo }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  合同编号<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="cotractNum">
                    <el-input v-model="info.cotractNum" placeholder="请输入合同编号" @input="oninput()" />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  实际付款人名称<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="drawee">
                    <el-input v-model="info.drawee" placeholder="请输入实际付款人名称" @blur="oninputdrawee()" />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户名称<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="orderUnit">
                    {{ info.orderUnit }}
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  实际付款人国家<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="sourceCountries">
                    <el-select
                      v-model="info.sourceCountries"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请输入实际付款人国家"
                      :remote-method="getCountryForName"
                      :loading="isSearchCountryLoading"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.englishShorterFormHand"
                        :label="item.englishShorterFormHand"
                        :value="item.englishShorterFormHand"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  付款金额<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="remittanceAmount">
                    <el-input-number v-model="info.remittanceAmount" :min="0" :precision="2" @input="inputs" />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  交易币种<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="currency">
                    {{ info.currencyName || '-' }}
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  付款日期<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="remittanceTime">
                    <el-date-picker
                      v-model="info.remittanceTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  付款方式<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="remittanceWay">
                    <el-select v-model="info.remittanceWay" placeholder="请选择付款方式">
                      <!-- <el-option v-for="(value, key) in remittanceWayList" :key="key+1" :label="value" :value="key+1" /> -->
                      <el-option
                        v-for="item in remittanceWayList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  付款用途<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="remittanceScenario">
                    <el-select v-model="info.remittanceScenario" placeholder="请选择付款用途">
                      <!-- <el-option v-for="(value, key) in remittanceScenarioList" :key="key+1" :label="value" :value="key+1" /> -->
                      <el-option
                        v-for="item in remittanceScenarioList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                <!-- {{ info.remittanceScenario }} -->
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇入公司<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="importCompany">
                    <el-select v-model="info.importCompany" filterable placeholder="请选择汇入公司" @change="listBankFn()">
                      <el-option v-for="(value, key) in importCompanyList" :key="key" :label="value" :value="value" />
                    </el-select>
                  </el-form-item>
                <!-- {{ info.importCompany }} -->
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇入账号<span class="required">*</span>：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="importAccount">
                    <el-select v-model="info.importAccount" placeholder="请选择汇入账号" @change="changeAccount()">
                      <el-option v-for="(value, key) in importAccountList" :key="key" :label="value" :value="value" />
                    </el-select>
                  </el-form-item>
                <!-- {{ info.importAccount }} -->
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  收款单号：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="telegraphicTransferNum">
                    <el-input v-model="info.telegraphicTransferNum" placeholder="请输入资管收款单号" @blur="blurs()" />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  实际到款金额：
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="actualRemittanceAmount">
                    <span v-if="info.telegraphicTransferNum === ''">-</span>
                    <span v-else>{{ info.actualRemittanceAmount }}</span>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  手续费：
                </div>
                <div class="rj-baseinfo__item">
                  <span v-if="info.telegraphicTransferNum === ''">-</span>
                  <span v-else-if="commission <= 50">{{ commission }}</span>
                  <span v-else-if="commission > 50" style="color: red;">{{ commission }}</span>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  是否委托付款:
                </div>
                <div class="rj-baseinfo__item">
                  <el-form-item prop="entrustedFlg">
                    <span v-if="info.entrustedFlg === '0' || info.entrustedFlg === 0">&nbsp;&nbsp;&nbsp;否</span>
                    <span v-if="info.entrustedFlg === '1' || info.entrustedFlg === 1">&nbsp;&nbsp;&nbsp;是</span>
                  </el-form-item>
                </div>
              </div>
            </div>
            <!-- 汇率维护 -->
            <div class="rj-row-title">汇率维护</div>
            <div class="exchange-rate-panel">
              <div class="rj-col-2">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    是否跨币种<span class="required">*</span>：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item prop="crossCurrencyFlag">
                      <el-select v-model="info.crossCurrencyFlag" :disabled="!info.telegraphicTransferNum" placeholder="请选择是否跨币种">
                        <el-option
                          v-for="item in crossCurrencyOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <template v-if="info.crossCurrencyFlag === '1' || info.crossCurrencyFlag === 1">
                <div class="rj-col-2">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      汇率日期<span v-show="info.exchangeRateRule === 'sameDayMiddleRate'" class="required">*</span>：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-form-item prop="exchangeRateDate">
                        <el-date-picker
                          v-model="info.exchangeRateDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="年 / 月 / 日"
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="rj-col-2">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      汇率取值规则<span class="required">*</span>：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-form-item prop="exchangeRateRule">
                        <el-select v-model="info.exchangeRateRule" placeholder="请选择汇率取值规则">
                          <el-option
                            v-for="item in exchangeRateRuleOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="rj-col-2">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      目标币种<span class="required">*</span>：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-form-item prop="targetCurrency">
                        <el-select v-model="info.targetCurrency" placeholder="请选择目标币种" @change="handleTargetCurrencyChange">
                          <el-option v-for="(value, key) in targetCurrencyList" :key="key" :label="value.currency" :value="value.currency" />
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="rj-col-2">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      本次应收金额<span class="required">*</span>：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-form-item prop="currentReceivableAmount">
                        <el-input-number v-model="info.currentReceivableAmount" :min="0" :precision="2" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="rj-col-2">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      汇率值<span class="required">*</span>：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-form-item prop="exchangeRate">
                        <el-input-number
                          v-model="info.exchangeRate"
                          :disabled="info.exchangeRateRule === 'sameDayMiddleRate'"
                          :precision="4"
                          :step="0.1"
                        />
                        <div v-show="needFluctuationCheck && fluctuationExceeded" class="exchange-rate-tip">
                          汇率相比波动超过5%，数仓汇率 {{ dataWarehouseExchangeRate }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="rj-col-2">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      转换金额：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-form-item prop="convertedAmount">
                        <el-input
                          v-model="info.convertedAmount"
                          disabled
                          placeholder="待系统取汇率后计算"
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="rj-col-1">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      虚拟来款单备注：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model.trim="info.erpVirtualReceiptRemark" type="textarea" :rows="1" placeholder="请输入备注" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <!-- 关联合同 -->
            <div class="rj-col-1 related-contract-title rj-row-title">关联合同</div>
            <div class="rj-col-1 related-contract-actions">
              <el-button type="primary" @click="contract()">
                添加
              </el-button>
              <span class="related-contract-tip">请按转账后余额分配</span>
            </div>
            <div class="rj-col-1">
              <el-table :data="info.telegraphicContractRelationList" border style="width: 100%">
                <el-table-column label="合同编码 *" align="left">
                  <template slot-scope="scope">
                    <el-form-item class="cotractNum_item" :error="getContractVerifyError(scope.$index)">
                      <el-input v-model="scope.row.cotractNum" placeholder="请输" @input="handleContractInput(scope.$index)" @blur="blursone(scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="拆分金额 *" align="left">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.splitAmount" placeholder="请输入拆分金额" oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" />
                  </template>
                </el-table-column>
                <el-table-column label="付款类型 *" align="left">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.remittanceType" placeholder="请选择">
                      <el-option label="现销付款/赊销预付款" :value="0" />
                      <el-option label="赊销回款" :value="1" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="台账" align="left">
                  <template slot-scope="scope">
                    <el-form-item :prop="`telegraphicContractRelationList.${scope.$index}.ledgerNumber`" :rules="{required:scope.row.remittanceType?true:false , message: '台账不能为空', trigger: 'blur'}">
                      <el-input v-model="scope.row.ledgerNumber" placeholder="请输入台账" maxlength="20" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="left">
                  <template slot-scope="scope">
                    <span style="text-align: center;width: 100%;cursor: pointer;color: rgb(28, 154, 212);" @click="buttonyichu(scope.$index)">
                      <span>移除</span>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  备注：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model.trim="info.remark" type="textarea" :rows="1" placeholder="请输入备注" />
                <!-- {{ info.remark }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div class="footer-btn">
      <el-button type="default" @click="dialogVisible = false">
        取消
      </el-button>
      <el-button :loading="isLoading" type="primary" @click="submit('form')">
        提交
      </el-button>
    </div>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </el-dialog>
</template>

<script>
import AxiosApi from '@/API/fileAxios';
import { attachmentGetToken } from '@/API';
import Big from 'big.js';
import { getNum } from '@/libs/util';
import { buildIntlTelegraphicTransferComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
import {
  addTelegraphicTransferInternationBusiness,
  verifyreceiptnumber,
  getCurrency,
  verifyContractNum,
  getOrderUnitAndCurrencyByContractNum,
  getCompanyAndBankByBusinessEntity,
  getCheckExchangeRateFluctuation,
  getExchangeRate,
  getTargetCurrency,
  currencys,
  listBank,
  getRemittanceConfig,
  getCreateTelNumber,
  listWaterOrderAttachment,
  acquiringCountry
} from '@/API/international.js';
function debounce (func, wait) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

function createDefaultContractRelation () {
  return {
    cotractNum: '',
    splitAmount: '',
    remittanceType: '',
    ledgerNumber: ''
  };
}

function createDefaultInfo () {
  return {
    remittanceTime: '', // 付款日期
    telegraphicTransferNo: '', // 汇款编号
    cotractNum: '', // 合同编号
    drawee: '', // 实际付款人名称
    orderUnit: '', // 客户名称
    sourceCountries: '', // 实际付款人国家
    remittanceAmount: 0, // 付款金额
    currency: '', // 交易币种
    remittanceWay: '', // 付款方式
    remittanceScenario: '', // 付款用途
    importCompany: '', // 汇入公司
    importAccount: '', // 汇入账号
    remark: '', // 备注
    currencyName: '', // 交易币种名称
    remittanceType: '', // 付款类型
    actualRemittanceAmount: '', // 实际到款金额
    entrustedFlg: '', // 是否委托付款
    telegraphicTransferNum: '', // 收款单号
    contractCurrency: '', // 合同币种
    receiptCurrency: '', // 收款单币种
    receiptAccount: '', // 收款单账号
    bussinessEntity: '', // 业务实体
    crossCurrencyFlag: '0', // 是否跨币种
    exchangeRateRule: 'sameDayMiddleRate', // 汇率取值规则
    exchangeRateDate: '', // 汇率日期
    targetCurrency: '', // 目标币种
    targetCurrencyName: '', // 目标币种名称
    currentReceivableAmount: '', // 本次应收金额
    exchangeRate: '', // 汇率值
    convertedAmount: '', // 转换金额
    convertedServiceFee: '', // 转换后手续费 本次应收金额  - (实际到账金额 / 汇率).fixed(2)
    convertedActualRemittanceAmount: '', // 转换后实际到账金额 (实际到账金额 / 汇率).fixed(2)
    virtualBankAccount: '', // 虚拟银行账户
    virtualBankAccountName: '', // 虚拟银行账户名称
    erpVirtualReceiptRemark: '', // ERP虚拟收款备注
    telegraphicContractRelationList: [createDefaultContractRelation()]
  };
}

const CONTRACT_VERIFY_STATUS = Object.freeze({
  INITIAL: '',
  SUCCESS: 'success',
  CUSTOMER_MISMATCH: 'customerMismatch',
  INVALID: 'invalid'
});

function createDefaultContractVerifyStatus () {
  return {
    status: CONTRACT_VERIFY_STATUS.INITIAL,
    contractCustomerName: ''
  };
}

export default {
  data () {
    // 验证汇率日期
    const validateExchangeRateDate = (rule, value, callback) => {
      const crossCurrencyFlag = this.info.crossCurrencyFlag === '1';
      const requiresExchangeRateDate = this.info.exchangeRateRule === 'sameDayMiddleRate';

      if (crossCurrencyFlag && requiresExchangeRateDate && !value) {
        callback(new Error('请选择汇率日期'));
        return;
      }

      callback();
    };

    // 验证目标币种
    const validateTargetCurrency = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择目标币种'));
        return;
      }

      if (this.info.currency && value === this.info.currency) {
        callback(new Error('交易币种和目标币种一致'));
        return;
      }

      callback();
    };

    const validateExchangeRate = (rule, value, callback) => {
      const crossCurrencyFlag = this.info.crossCurrencyFlag === '1';

      if (!crossCurrencyFlag) {
        callback();
        return;
      }

      if (value === '' || value === null || value === undefined || Number(value) <= 0) {
        callback(new Error('请输入大于0的汇率值'));
        return;
      }

      callback();
    };

    return {
      isLoading: false,
      isUploadLoading: false,
      isshoukuan: '', // 编辑收款单号
      contractVerifyStatusList: [createDefaultContractVerifyStatus()],
      commission: '', // 手续费
      dialogVisible: this.messageInputDialog,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: '',
      tableData: [],
      fileList: [],
      info: createDefaultInfo(),
      fluctuationExceeded: false, // 波动比例是否严格大于 0.05
      needFluctuationCheck: false, // 是否需要进行数仓汇率波动校验。
      dataWarehouseExchangeRate: null, // 数仓汇率
      currencyList: [],
      targetCurrencyList: [], // 目标币种列表
      crossCurrencyOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ],
      remittanceWayList: [],
      remittanceScenarioList: [],
      importCompanyList: [],
      remittanceTypeList: [],
      importAccountList: [],
      countryList: [], // 国家列表
      isSearchCountryLoading: false,
      manualRateSyncSource: '',
      manualRateAnchorField: '',
      rules: {
        cotractNum: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
          // { validator: validateContractNum, trigger: 'blur' }
        ],
        drawee: [
          { required: true, message: '请输入实际付款人名称', trigger: 'blur' }
        ],
        orderUnit: [
          { required: true, message: '请输入客户名称', trigger: 'change' }
        ],
        sourceCountries: [
          { required: true, message: '请输入实际付款人国家', trigger: 'blur' }
        ],
        remittanceAmount: [
          { required: true, message: '请输入付款金额', trigger: 'blur' }
        ],
        currency: [
          { required: true, message: '请输入交易币种', trigger: 'change' }
        ],
        remittanceTime: [
          { required: true, message: '请输入付款日期', trigger: 'change' }
        ],
        remittanceWay: [
          { required: true, message: '请输入付款方式', trigger: 'change' }
        ],
        remittanceScenario: [
          { required: true, message: '请输入付款用途', trigger: 'change' }
        ],
        importCompany: [
          { required: true, message: '请输入汇入公司', trigger: 'change' }
        ],
        importAccount: [
          { required: true, message: '请输入汇入账号', trigger: 'change' }
        ],
        crossCurrencyFlag: [
          { required: true, message: '请选择是否跨币种', trigger: 'change' }
        ],
        exchangeRateDate: [
          { validator: validateExchangeRateDate, trigger: 'change' }
        ],
        exchangeRateRule: [
          { required: true, message: '请选择汇率取值规则', trigger: 'change' }
        ],
        targetCurrency: [
          { validator: validateTargetCurrency, trigger: 'change' }
        ],
        currentReceivableAmount: [
          { required: true, message: '请输入本次应收金额', trigger: 'blur' }
        ],
        exchangeRate: [
          { validator: validateExchangeRate, trigger: 'blur' }
        ]
        // entrustedFlg: [
        //   { required: true, message: '请输入是否委托付款', trigger: 'change' }
        // ]
      }
    };
  },
  methods: {
    // 判断是否手动汇率规则
    isManualExchangeRateRule () {
      return ['poAgreedRate', 'otherAgreedRate'].includes(this.info.exchangeRateRule);
    },
    // 判断是否跨币种
    isCrossCurrency () {
      return this.info.crossCurrencyFlag === '1' || this.info.crossCurrencyFlag === 1;
    },
    // 重置跨币种相关字段
    resetCrossCurrencyFields (target = this.info) {
      target.exchangeRateDate = '';
      target.targetCurrency = '';
      target.targetCurrencyName = '';
      target.currentReceivableAmount = '';
      target.exchangeRate = '';
      target.convertedAmount = '';
      target.convertedServiceFee = '';
      target.convertedActualRemittanceAmount = '';
      target.virtualBankAccount = '';
      target.virtualBankAccountName = '';
    },
    // 构建提交数据
    buildSubmitPayload () {
      const payload = {
        ...this.info,
        attachmentList: this.fileList
      };

      if (!this.isCrossCurrency()) {
        this.resetCrossCurrencyFields(payload);
        return payload;
      }

      const actualRemittanceAmount = Number(this.info.actualRemittanceAmount || 0);
      const exchangeRate = Number(this.info.exchangeRate || 0);
      const convertedActualRemittanceAmount = exchangeRate > 0 ? (actualRemittanceAmount / exchangeRate).toFixed(2) : '';
      payload.convertedActualRemittanceAmount = convertedActualRemittanceAmount;
      payload.convertedServiceFee = (Number(this.info.currentReceivableAmount || 0) - Number(convertedActualRemittanceAmount || 0)).toFixed(2);

      this.targetCurrencyList.forEach((item) => {
        if (item.currency === this.info.targetCurrency) {
          payload.virtualBankAccount = item.virtualBankAccount;
          payload.virtualBankAccountName = item.virtualBankName;
        }
      });

      return payload;
    },
    // 同步手动汇率规则下的本次应收金额
    syncManualCurrentReceivableAmount () {
      if (!this.isManualExchangeRateRule()) {
        this.updateConvertedAmounts();
        return;
      }

      if (!this.info.exchangeRate || Number(this.info.exchangeRate) <= 0) {
        this.manualRateSyncSource = 'exchangeRate';
        this.info.currentReceivableAmount = '';
        this.info.convertedAmount = '';
        return;
      }

      const currentReceivableAmount = (Number(this.info.remittanceAmount || 0) / Number(this.info.exchangeRate)).toFixed(2);
      this.manualRateAnchorField = 'exchangeRate';
      this.manualRateSyncSource = 'exchangeRate';
      this.info.currentReceivableAmount = Number(currentReceivableAmount);
      this.info.convertedAmount = currentReceivableAmount;
    },
    // 同步手动汇率规则下的汇率值
    syncManualExchangeRate () {
      if (!this.isManualExchangeRateRule()) {
        return;
      }

      if (!this.info.currentReceivableAmount || Number(this.info.currentReceivableAmount) <= 0) {
        this.manualRateSyncSource = 'currentReceivableAmount';
        this.info.exchangeRate = '';
        this.info.convertedAmount = '';
        return;
      }

      const exchangeRate = (Number(this.info.remittanceAmount || 0) / Number(this.info.currentReceivableAmount)).toFixed(4);
      this.manualRateAnchorField = 'currentReceivableAmount';
      this.manualRateSyncSource = 'currentReceivableAmount';
      this.info.exchangeRate = Number(exchangeRate);
      this.info.convertedAmount = Number(this.info.currentReceivableAmount).toFixed(2);
    },
    // 同步手动汇率规则下的锚字段
    syncManualExchangeRateByAnchor () {
      if (!this.isManualExchangeRateRule()) {
        this.updateConvertedAmounts();
        return;
      }

      if (this.manualRateAnchorField === 'currentReceivableAmount') {
        this.syncManualExchangeRate();
        return;
      }

      this.syncManualCurrentReceivableAmount();
    },
    // 汇率值校验
    validateExchangeRateFluctuation () {
      if (!this.isCrossCurrency() || !this.info.exchangeRate || Number(this.info.exchangeRate) <= 0) {
        return;
      }
      // 汇率时间没有取当天时间
      const exchangeRateDate = this.info.exchangeRateDate || this.getDayRange().startDate.split(' ')[0];

      const params = {
        importAccount: this.info.importAccount,
        exchangeRateDate,
        targetCurrency: this.info.targetCurrency,
        exchangeRate: this.info.exchangeRate,
        exchangeRateRule: this.info.exchangeRateRule
      };

      getCheckExchangeRateFluctuation(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fluctuationExceeded = json.data.fluctuationExceeded;
          this.needFluctuationCheck = json.data.needFluctuationCheck;
          this.dataWarehouseExchangeRate = json.data.dataWarehouseExchangeRate;
        } else {
          this.$message.warning(json.err || json.message || json.error || json.msg || '汇率值校验失败');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    refreshExchangeRateValidation () {
      if (!this.$refs.form) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate('exchangeRate');
      });
    },
    changeAccount () {
      getCurrency(this.info.importAccount).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.info.currencyName = json.data.currencyName;
          this.info.currency = json.data.currencyCode;
          if (this.info.targetCurrency && this.info.currency) {
            this.getRateList(); // 获取汇率数据
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    guanbi () {
      const infos = [createDefaultContractRelation()];
      this.info.telegraphicContractRelationList = infos;
      this.contractVerifyStatusList = [createDefaultContractVerifyStatus()];
      this.commission = '';
      this.manualRateSyncSource = '';
      this.manualRateAnchorField = '';
    },
    blurs () {
      this.info.telegraphicTransferNum = (this.info.telegraphicTransferNum || '').trim();
      if (this.info.telegraphicTransferNum === '') {
        this.info.actualRemittanceAmount = ''; // 实际到款金额
        this.commission = ''; // 手续费
        this.info.crossCurrencyFlag = '0'; // 是否跨币种
        this.info.receiptCurrency = ''; // 收款单币种
        this.info.receiptAccount = ''; // 收款单账号
      };
      let params = {
        receiptNumber: this.info.telegraphicTransferNum, // 收款单号
        type: this.iswei
      };
      if (this.info.telegraphicTransferNum !== '') {
        verifyreceiptnumber(params).then((res) => {
          const json = res.data;
          if (json.status === '200') {
            if (json.data.isReceipt === true) {
              this.$message.success('该收款单号已生成收款单');
              return;
            }
            this.info.bussinessEntity = json.data.bussinessEntity; // 业务实体
            this.getBusinessEntityList(this.info.bussinessEntity);
            this.getTargetCurrencyList(this.info.bussinessEntity);
            this.info.actualRemittanceAmount = json.data.actualRemittanceAmount; // 实际到款金额
            this.commission = (this.info.remittanceAmount - this.info.actualRemittanceAmount).toFixed(2); // 手续费
            this.info.receiptCurrency = json.data.currency; // 收款单币种
            this.info.receiptAccount = json.data.account; // 收款单账号
            if (this.info.contractCurrency && this.info.receiptCurrency) {
              this.info.crossCurrencyFlag = this.info.contractCurrency !== this.info.receiptCurrency ? '1' : '0'; // 是否跨币种
            }
          } else {
            this.info.actualRemittanceAmount = ''; // 实际到款金额
            this.commission = ''; // 手续费
            this.info.crossCurrencyFlag = '0'; // 是否跨币种
            this.info.receiptCurrency = ''; // 收款单币种
            this.info.receiptAccount = ''; // 收款单账号
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    // 根据业务实体获取汇入公司，账号，交易币种等列表数据
    getBusinessEntityList (businessEntity = '') {
      let params = {
        businessEntity
      };
      getCompanyAndBankByBusinessEntity(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          let businessEntityList = json.data.companyList || []; // 业务实体列表
          let companyList = {}; // 用于存储匹配的汇入公司信息
          businessEntityList.forEach(item => {
            item.accountList.forEach(account => {
              if (account.accountNo === this.info.receiptAccount) {
                companyList = item;
              }
            });
          });
          if (!businessEntity) {
            this.importCompanyList = businessEntityList.map(item => item.companyName); // 导入公司列表
          }
          if (businessEntity && Object.keys(companyList).length > 0) { // 如果有业务实体，默认选中第一个汇入公司
            this.info.importCompany = companyList.companyName; // 汇入公司, 默认选中第一个
            this.importAccountList = companyList.accountList.map(item => item.accountNo); // 汇入账号列表
            this.info.importAccount = companyList.accountList.find(item => item.accountNo === this.info.receiptAccount)?.accountNo || ''; // 汇入账号
            this.info.currency = companyList.accountList.find(item => item.accountNo === this.info.receiptAccount)?.currencyCode || ''; // 交易币种
            this.info.currencyName = companyList.accountList.find(item => item.accountNo === this.info.receiptAccount)?.currencyName || ''; // 交易币种
            if (this.info.targetCurrency && this.info.currency) {
              this.getRateList(); // 获取汇率数据
            }
          } else {
            this.importAccountList = []; // 清空汇入账号列表
            this.info.importAccount = ''; // 清空汇入账号
            this.info.importCompany = ''; // 清空汇入公司
            this.info.currency = ''; // 清空交易币种
            this.info.currencyName = ''; // 清空交易币种名称
          }
        } else {
          this.importCompanyList = []; // 清空汇入公司列表
          this.importAccountList = []; // 清空汇入账号列表
          this.info.importAccount = ''; // 清空汇入账号
          this.info.importCompany = ''; // 清空汇入公司
          this.info.currency = ''; // 清空交易币种
          this.info.currencyName = ''; // 清空交易币种名称
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    updateConvertedAmounts () {
      if (!this.info.exchangeRate || Number(this.info.exchangeRate) <= 0) {
        this.info.convertedAmount = '';
        this.info.currentReceivableAmount = '';
        return;
      }

      this.info.convertedAmount = (this.info.remittanceAmount / this.info.exchangeRate).toFixed(2); // 转换金额 = 付款金额 * 汇率值
      this.info.currentReceivableAmount = this.info.convertedAmount; // 本次应收金额 = 转换金额
    },
    // 当目标币种发生变化时，获取汇率数据
    handleTargetCurrencyChange () {
      this.info.targetCurrencyName = this.targetCurrencyList.find(item => item.currency === this.info.targetCurrency)?.currencyName || '';
      if (this.info.targetCurrency && this.info.currency) {
        this.getRateList();
      }
    },
    // 获取指定日期的起始和结束时间，默认使用当天
    getDayRange (dateText = '') {
      let targetDateText = dateText;
      if (!targetDateText) {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = `${currentDate.getMonth() + 1}`.padStart(2, '0');
        const day = `${currentDate.getDate()}`.padStart(2, '0');
        targetDateText = `${year}-${month}-${day}`;
      }

      return {
        startDate: `${targetDateText} 00:00:00`,
        endDate: `${targetDateText} 23:59:59`
      };
    },
    // 获取汇率数据
    getRateList () {
      if (!this.info.currency || !this.info.targetCurrency) {
        return;
      }
      const { startDate, endDate } = this.getDayRange(this.info.exchangeRateDate);
      getExchangeRate({
        pageNo: 1,
        pageSize: 100,
        inFields: {
          CONVERSION_SDATE: startDate,
          CONVERSION_EDATE: endDate,
          FROM_CURRENCY: this.info.targetCurrency,
          TO_CURRENCY: this.info.currency,
          CONVERSION_TYPE: 'Corporate'
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          if (this.info.exchangeRateRule === 'sameDayMiddleRate') {
            this.info.exchangeRate = json.data.data.find(item => item.TO_CURRENCY === this.info.currency && item.FROM_CURRENCY === this.info.targetCurrency)?.CONVERSION_RATE || '';
            this.updateConvertedAmounts();
          }
        } else {
          this.info.exchangeRate = '';
          this.$message.error('获取汇率失败，请检查币种是否正确');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 获取目标币种数据
    getTargetCurrencyList (businessEntity = '') {
      let params = {
        businessEntity
      };
      getTargetCurrency(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.targetCurrencyList = json.data || []; // 目标币种列表
          if (this.targetCurrencyList.length === 1) {
            this.info.targetCurrency = this.targetCurrencyList[0].currency; // 默认选中第一个目标币种
            this.info.targetCurrencyName = this.targetCurrencyList[0].currencyName || ''; // 默认选中第一个目标币种名称
            if (this.info.currency) {
              this.getRateList();
            }
            this.$nextTick(() => {
              this.$refs.form && this.$refs.form.clearValidate('targetCurrency');
            });
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 计算手续费和转换金额
    inputs () {
      this.commission = (this.info.remittanceAmount - this.info.actualRemittanceAmount).toFixed(2);
      this.syncManualExchangeRateByAnchor();
    },
    getContractVerifyStatus (index) {
      const verifyStatus = this.contractVerifyStatusList[index];

      if (verifyStatus && typeof verifyStatus === 'object') {
        return {
          status: verifyStatus.status || CONTRACT_VERIFY_STATUS.INITIAL,
          contractCustomerName: verifyStatus.contractCustomerName || ''
        };
      }

      return {
        status: verifyStatus || CONTRACT_VERIFY_STATUS.INITIAL,
        contractCustomerName: ''
      };
    },
    setContractVerifyStatus (index, status = CONTRACT_VERIFY_STATUS.INITIAL, contractCustomerName = '') {
      if (index < 0) {
        return;
      }

      this.$set(this.contractVerifyStatusList, index, {
        status,
        contractCustomerName
      });
    },
    buildContractVerifyErrorMessage (contractCustomerName = '') {
      const currentCustomerName = this.info.orderUnit || '';

      if (contractCustomerName) {
        return `该合同客户名称为“${contractCustomerName}”`;
      }

      return `合同客户与汇款单客户名称“${currentCustomerName}”不一致`;
    },
    getContractVerifyError (index) {
      const { status, contractCustomerName } = this.getContractVerifyStatus(index);

      if (status === CONTRACT_VERIFY_STATUS.CUSTOMER_MISMATCH) {
        return this.buildContractVerifyErrorMessage(contractCustomerName);
      }

      if (status === CONTRACT_VERIFY_STATUS.INVALID) {
        return '请输入正确的合同编号';
      }

      return '';
    },
    // 校验关联合同模块，合同编号
    handleContractInput (index) {
      if (index < 0) {
        return;
      }

      this.setContractVerifyStatus(index);
    },
    blursone (index) {
      const currentItem = this.info.telegraphicContractRelationList[index];
      if (!currentItem) {
        return;
      }

      currentItem.cotractNum = (currentItem.cotractNum || '').trim();
      if (currentItem.cotractNum !== '') {
        let parmas1 = {
          contractNum: currentItem.cotractNum
        };
        verifyContractNum(parmas1).then((res) => {
          const json = res.data;
          if (json.status === '200') {
            const contractCustomerName = json.data || '';
            if (contractCustomerName !== this.info.orderUnit) {
              this.setContractVerifyStatus(index, CONTRACT_VERIFY_STATUS.CUSTOMER_MISMATCH, contractCustomerName);
              this.$message({
                message: `合同客户与汇款单客户名称不一致，请重新输入`,
                type: 'warning'
              });
            } else {
              this.setContractVerifyStatus(index, CONTRACT_VERIFY_STATUS.SUCCESS, contractCustomerName);
            }
          } else if (json.status === '7100218') {
            this.setContractVerifyStatus(index, CONTRACT_VERIFY_STATUS.INVALID);
          }
        }).catch((err) => {
          console.log(err);
        });
        return;
      }

      this.setContractVerifyStatus(index);
    },
    contract () {
      this.info.telegraphicContractRelationList.push(createDefaultContractRelation());
      this.contractVerifyStatusList.push(createDefaultContractVerifyStatus());
    },
    buttonyichu (e) {
      this.info.telegraphicContractRelationList.splice(e, 1);
      this.contractVerifyStatusList.splice(e, 1);
    },
    isEtrusted () {
      if (this.info.drawee !== this.info.orderUnit) {
        this.info.entrustedFlg = '1';
      } else {
        this.info.entrustedFlg = '0';
      }
    },
    oninputdrawee () {
      this.info.drawee = this.info.drawee.trim();
      this.isEtrusted();
    },
    // 20240614 pm要求去掉全部特殊字符 郭加军这边说先不动 等他讨论下再说
    checkSpecialCharacters (str) {
    // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*()=|{}':;'\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。、？]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    getValues (object) {
      let arr = Object.values(object);
      return arr;
    },
    close () {
      this.$refs.form.resetFields();
      this.fileList = [];
      this.info.remark = '';
      this.dialogVisible = false;
      this.guanbi();
    },
    oninput: debounce(function () {
      let parmas = {
        contractNum: this.info.cotractNum
      };
      getOrderUnitAndCurrencyByContractNum(parmas).then((res) => {
        const json = res.data;

        if (json.status === '200') {
          this.$set(this.info, 'orderUnit', json.data.orderUnit);
          this.$set(this.info, 'contractCurrency', json.data.currencyId); // 合同币种
          if (this.info.contractCurrency && this.info.receiptCurrency) {
            this.info.crossCurrencyFlag = this.info.contractCurrency !== this.info.receiptCurrency ? '1' : '0'; // 是否跨币种
          }
        } else {
          this.$set(this.info, 'orderUnit', '');
          this.$set(this.info, 'contractCurrency', '');
        }
        this.isEtrusted();
      }).catch(() => {
        this.$set(this.info, 'orderUnit', '');
        this.$set(this.info, 'contractCurrency', '');
        this.isEtrusted();
      });
    }, 800),
    // 提交表单
    submit (formName) {
      this.info.telegraphicTransferNum = (this.info.telegraphicTransferNum || '').trim();
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 校验合同编号
          if (!this.info.orderUnit) {
            this.$message.error('请输入正确的合同编号！');
            return;
          }
          if (!this.info.remittanceAmount || this.info.remittanceAmount <= 0) {
            this.$message.error('付款金额必须大于0！');
            return;
          }
          // 根据币种code 找对应的名称
          this.currencyList.forEach((item) => {
            if (item.currencyCode === this.info.currency) {
              this.info.currencyName = item.currencyName;
            }
          });
          this.isLoading = true;
          // 国际商务录入电汇单：提交前出口合规预检
          const complianceDecision = await checkIntlExportCompliance(this,
            buildIntlTelegraphicTransferComplianceRequest(this.info));
          if (!complianceDecision.allowBusiness) {
            this.isLoading = false;
            return;
          }
          let parmasone = this.buildSubmitPayload();
          if (this.info.actualRemittanceAmount <= this.info.remittanceAmount) { // 实际到款金额小于等于付款金额
            let piace = new Big(0);
            this.info.telegraphicContractRelationList.forEach((item) => {
              piace = piace.plus(getNum(item.splitAmount));
            });
            // 如果是跨币种核销，拆分金额总和必须等于本次应收金额，否则等于付款金额
            const splitAmountSum = this.info.crossCurrencyFlag === '1' ? (this.info.currentReceivableAmount || 0) : (this.info.remittanceAmount || 0);
            if (splitAmountSum === piace.toNumber()) {
              const invalidContractVerifyStatus = this.info.telegraphicContractRelationList.reduce((result, item, index) => {
                if (result) {
                  return result;
                }

                const verifyStatus = this.getContractVerifyStatus(index);
                return verifyStatus.status !== CONTRACT_VERIFY_STATUS.SUCCESS ? verifyStatus : null;
              }, null);
              console.log('invalidContractVerifyStatus', invalidContractVerifyStatus);
              if (invalidContractVerifyStatus) {
                this.isLoading = false;
                this.$message({
                  message: '合同客户与汇款单客户名称不一致，请重新输入',
                  type: 'warning'
                });
                return;
              }
              if (this.info.entrustedFlg === '1' || this.info.entrustedFlg === 1) { // 委托付款
                if (parmasone.attachmentList.length !== 0) { // 委托付款附件不为空，否则提示上传附件
                  let params = {
                    receiptNumber: this.info.telegraphicTransferNum, // 收款单号
                    type: this.iswei
                  };
                  if (this.info.telegraphicTransferNum !== '') {
                    if (this.iswei === 1 && this.isshoukuan === this.info.telegraphicTransferNum) { // 编辑，收款单号不变
                      addTelegraphicTransferInternationBusiness(parmasone).then((res) => {
                        this.isLoading = false;
                        const json = res.data;
                        if (json.status === '200') {
                          this.$message.success('提交成功');
                          this.close();
                        }
                      }).catch(() => {
                        this.isLoading = false;
                      });
                    } else {
                      verifyreceiptnumber(params).then((res) => {
                        const json = res.data;
                        if (json.status === '200') {
                          if (json.data.isReceipt === true) {
                            this.isLoading = false;
                            this.$message.success('该收款单号已生成收款单');
                            return false;
                          }
                          // 福建锐捷 公司和账号手动选择，不需要走校验
                          if (this.info.bussinessEntity !== '福建锐捷' && json.data.account !== this.info.importAccount) {
                            this.isLoading = false;
                            this.$message.warning('收款单汇入账号与所选汇入账号不一致');
                            return false;
                          }
                          this.info.actualRemittanceAmount = json.data.actualRemittanceAmount;
                          this.commission = (this.info.remittanceAmount - this.info.actualRemittanceAmount).toFixed(2);
                          addTelegraphicTransferInternationBusiness(parmasone).then((res) => {
                            this.isLoading = false;
                            const json = res.data;
                            if (json.status === '200') {
                              this.$message.success('提交成功');
                              this.close();
                            }
                          }).catch(() => {
                            this.isLoading = false;
                          });
                        }
                      }).catch((err) => {
                        this.isLoading = false;
                        console.log(err);
                      });
                    }
                  } else { // 收款单号为空
                    addTelegraphicTransferInternationBusiness(parmasone).then((res) => {
                      this.isLoading = false;
                      const json = res.data;
                      if (json.status === '200') {
                        this.$message.success('提交成功');
                        this.close();
                      }
                    }).catch(() => {
                      this.isLoading = false;
                    });
                  }
                } else {
                  this.isLoading = false;
                  this.$message({
                    message: '委托付款附件必传，请上传委托付款附件',
                    type: 'warning'
                  });
                }
              } else if (this.info.entrustedFlg === '0' || this.info.entrustedFlg === 0) { // 非委托付款
                let params = {
                  receiptNumber: this.info.telegraphicTransferNum,
                  type: this.iswei
                };
                if (this.info.telegraphicTransferNum !== '') {
                  if (this.iswei === 1 && this.isshoukuan === this.info.telegraphicTransferNum) { // 编辑，收款单号不变
                    addTelegraphicTransferInternationBusiness(parmasone).then((res) => {
                      this.isLoading = false;
                      const json = res.data;
                      if (json.status === '200') {
                        this.$message.success('提交成功');
                        this.close();
                      }
                    }).catch(() => {
                      this.isLoading = false;
                    });
                  } else {
                    verifyreceiptnumber(params).then((res) => {
                      const json = res.data;
                      if (json.status === '200') {
                        if (json.data.isReceipt === true) {
                          this.isLoading = false;
                          this.$message.success('该收款单号已生成收款单');
                          return false;
                        }
                        if (this.info.bussinessEntity !== '福建锐捷' && json.data.account !== this.info.importAccount) {
                          this.isLoading = false;
                          this.$message.warning('收款单汇入账号与所选汇入账号不一致');
                          return false;
                        }
                        this.info.actualRemittanceAmount = json.data.actualRemittanceAmount;
                        this.commission = (this.info.remittanceAmount - this.info.actualRemittanceAmount).toFixed(2);
                        addTelegraphicTransferInternationBusiness(parmasone).then((res) => {
                          this.isLoading = false;
                          const json = res.data;
                          if (json.status === '200') {
                            this.$message.success('提交成功');
                            this.close();
                          }
                        }).catch(() => {
                          this.isLoading = false;
                        });
                      }
                    }).catch((err) => {
                      console.log(err);
                    });
                  }
                } else {
                  addTelegraphicTransferInternationBusiness(parmasone).then((res) => {
                    this.isLoading = false;
                    const json = res.data;
                    if (json.status === '200') {
                      this.$message.success('提交成功');
                      this.close();
                    }
                  }).catch(() => {
                    this.isLoading = false;
                  });
                }
              }
            } else {
              this.isLoading = false;
              this.$message({
                message: `合同拆分金额之和需等于${this.info.crossCurrencyFlag === '1' ? '本次应收金额' : '付款金额'}，请重新输入`,
                type: 'warning'
              });
            };
          } else {
            this.isLoading = false;
            this.$message({
              message: '实际到款金额应小于等于付款金额，请重新输入',
              type: 'warning'
            });
          };
        } else {
          this.isLoading = false;
          return false;
        }
      });
    },
    getCreateTelNumberFn () {
      getCreateTelNumber().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.info.telegraphicTransferNo = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    remittanceScenarioListFn () {
      getRemittanceConfig(1).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          Object.keys(json.data).forEach(key => {
            let obj = {
              label: json.data[key],
              value: Number(key)
            };
            this.remittanceScenarioList.push(obj);
          });
          // this.remittanceScenarioList = this.getValues(json.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    remittanceWayListFn () {
      getRemittanceConfig(0).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          Object.keys(json.data).forEach(key => {
            let obj = {
              label: json.data[key],
              value: Number(key)
            };
            this.remittanceWayList.push(obj);
          });
          // this.remittanceWayList = list;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    remittanceTypeListFn () {
      getRemittanceConfig(2).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.remittanceTypeList = this.getValues(json.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 币种
    currencysFn () {
      currencys().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.currencyList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 汇入公司切换change
    listBankFn () {
      this.info.importAccount = '';
      this.getImportAccountList(this.info.importCompany);
    },
    // 获取汇入账号列表
    getImportAccountList (companyName) {
      listBank({ companyName }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.importAccountList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    getTime () {
      var toDay = new Date();
      var year = toDay.getFullYear(); // 年
      var month = toDay.getMonth() + 1 < 10 ? '0' + (toDay.getMonth() + 1) : toDay.getMonth() + 1; // 月
      var data = toDay.getDate() < 10 ? '0' + toDay.getDate() : toDay.getDate(); // 日
      var hour = toDay.getHours() < 10 ? '0' + toDay.getHours() : toDay.getHours(); // 时
      var minute = toDay.getMinutes() < 10 ? '0' + toDay.getMinutes() : toDay.getMinutes(); // 分
      var second = toDay.getSeconds() < 10 ? '0' + toDay.getSeconds() : toDay.getSeconds(); // 秒
      var today = year + '-' + month + '-' + data + ' ' + hour + ':' + minute + ':' + second;
      return today;
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    remove (index) {
      this.fileList.splice(index, 1);
    },
    download (row) {
      location.href = row.fileUrl;
      // this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      // this.$nextTick(() => {
      //   this.$refs.downTag.click();
      // });
    },
    loadEditTargetCurrencyOptions (detail = {}) {
      if (!detail.businessEntity) {
        return;
      }

      getTargetCurrency({
        businessEntity: detail.businessEntity
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.targetCurrencyList = json.data || [];
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    getInfo () {
      listWaterOrderAttachment(this.rowData.id).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          if (json.data.telegraphicTransferNum !== '') {
            this.isshoukuan = json.data.telegraphicTransferNum;
          }
          this.info = json.data;
          this.info.crossCurrencyFlag = json.data.crossCurrencyFlag + ''; // 是否跨币种
          this.info.exchangeRateDate = json.data.exchangeRateDate ? json.data.exchangeRateDate.split(' ')[0] : ''; // 汇率日期
          if (!Array.isArray(this.info.telegraphicContractRelationList) || !this.info.telegraphicContractRelationList.length) {
            this.$set(this.info, 'telegraphicContractRelationList', createDefaultInfo().telegraphicContractRelationList);
            this.contractVerifyStatusList = [createDefaultContractVerifyStatus()];
          } else {
            this.info.telegraphicContractRelationList = this.info.telegraphicContractRelationList.map(item => ({
              cotractNum: item.cotractNum || '',
              splitAmount: item.splitAmount || '',
              remittanceType: item.remittanceType === 0 || item.remittanceType === 1 ? item.remittanceType : (item.remittanceType || ''),
              ledgerNumber: item.ledgerNumber || ''
            }));
            this.contractVerifyStatusList = this.info.telegraphicContractRelationList.map(item => ({
              status: item.cotractNum ? CONTRACT_VERIFY_STATUS.SUCCESS : CONTRACT_VERIFY_STATUS.INITIAL,
              contractCustomerName: '' // 回显，有合同编号就代表校验成功
            }));
          }
          this.fileList = json.data.attachmentList;
          this.getCountryForName(this.info.sourceCountries);
          this.getImportAccountList(this.info.importCompany); // 获取汇入账号列表
          this.loadEditTargetCurrencyOptions(json.data); // 加载编辑时的目标币种列表
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    open () {
      this.info = createDefaultInfo();
      this.contractVerifyStatusList = [createDefaultContractVerifyStatus()];
      if (this.isEdit) {
        this.getInfo();
      } else {
        this.getCreateTelNumberFn();
      }
    },
    uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      const form = new FormData(); // 创建form对象
      form.append('file', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.isUploadLoading = true;
      AxiosApi.post('/telegraphicTransferInternation/ai-recognition-file', form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        this.isUploadLoading = false;
        const json = res.data;
        const responseData = json.data || {};
        const importCompanyList = Array.isArray(responseData.importCompany)
          ? responseData.importCompany
          : [];
        if (Number(json.status) === 200) {
          this.info.drawee = responseData.payerName || '';
          this.isEtrusted();
          this.info.sourceCountries = responseData.payerCountryName || '';
          this.info.remittanceAmount = responseData.paymentAmount;
          this.info.currency = responseData.transactionCurrency || '';
          if (importCompanyList.length > 0) {
            this.info.importCompany = importCompanyList[0];
          }
          this.info.importAccount = responseData.beneficiaryAccount || '';
          if (responseData.paymentMethod) {
            this.remittanceWayList.forEach((item, index) => {
              if (item.label === responseData.paymentMethod) {
                this.info.remittanceWay = item.value;
              }
            });
          }
          this.info.remittanceTime = responseData.paymentDate || '';
          if (responseData.paymentPurpose) {
            this.remittanceScenarioList.forEach((item, index) => {
              if (item.label === responseData.paymentPurpose) {
                this.info.remittanceScenario = item.value;
              }
            });
          }
          this.fileList.push({
            fileName: responseData.fileName || upload.file.name,
            createBy: responseData.createUser || '',
            createTime: responseData.createTime || '',
            fileUrl: responseData.fileUrl || ''
          });
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        this.isUploadLoading = false;
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    getCountryForName (name) {
      this.isSearchCountryLoading = true;
      acquiringCountry(name).then(({ data: res }) => {
        if (Number(res.status) === 200) {
          this.countryList = res.data || [];
        }
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.isSearchCountryLoading = false;
      });
    }
  },
  props: {
    messageInputDialog: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    iswei: {
      type: Number,
      default: () => {
        return {};
      }
    }
  },
  mounted () {
    this.initToken();
    this.fileList = [];
    this.currencysFn();
    this.getBusinessEntityList();
    this.remittanceScenarioListFn();
    this.remittanceWayListFn();
    this.remittanceTypeListFn();
  },
  watch: {
    messageInputDialog (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    },
    'info.crossCurrencyFlag' (value) {
      if (value === '1' || value === 1) {
        return;
      }

      this.resetCrossCurrencyFields();
      this.manualRateSyncSource = '';
      this.manualRateAnchorField = '';

      if (!this.$refs.form) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate('exchangeRateDate');
        this.$refs.form.clearValidate('targetCurrency');
        this.$refs.form.clearValidate('currentReceivableAmount');
        this.$refs.form.clearValidate('exchangeRate');
      });
    },
    'info.currency' () {
      if (!this.$refs.form) {
        return;
      }

      this.$nextTick(() => {
        if (this.info.targetCurrency) {
          this.$refs.form.validateField('targetCurrency');
          return;
        }

        this.$refs.form.clearValidate('targetCurrency');
      });
    },
    'info.remittanceAmount' () {
      this.syncManualExchangeRateByAnchor();
    },
    'info.exchangeRateRule' () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate('exchangeRateDate');
        this.$refs.form.clearValidate('exchangeRate');
      }

      this.manualRateSyncSource = '';

      if (this.info.exchangeRateRule === 'sameDayMiddleRate') {
        if (this.info.targetCurrency && this.info.currency) {
          this.getRateList();
        }
        return;
      }

      this.manualRateAnchorField = '';
      this.info.exchangeRate = 0;
      this.info.currentReceivableAmount = '';
      this.info.convertedAmount = '';
    },
    'info.exchangeRateDate' () {
      if (this.info.targetCurrency && this.info.currency) {
        this.getRateList();
      }
    },
    'info.currentReceivableAmount' () {
      if (this.manualRateSyncSource === 'exchangeRate') {
        this.manualRateSyncSource = '';
        return;
      }

      this.manualRateAnchorField = 'currentReceivableAmount';
      this.syncManualExchangeRate();
    },
    'info.exchangeRate' () {
      // 当汇率为空或小于等于0时，重置相关字段
      if (!this.info.exchangeRate || Number(this.info.exchangeRate) <= 0) {
        this.fluctuationExceeded = false;
        this.needFluctuationCheck = false;
        this.dataWarehouseExchangeRate = null;
      } else {
        this.refreshExchangeRateValidation();
      }
      this.validateExchangeRateFluctuation();
      if (this.manualRateSyncSource === 'currentReceivableAmount') {
        this.manualRateSyncSource = '';
        return;
      }
      if (this.isManualExchangeRateRule()) {
        this.manualRateAnchorField = 'exchangeRate';
        this.syncManualCurrentReceivableAmount();
        return;
      }

      this.updateConvertedAmounts();
    },
    'info.bussinessEntity' () {
      let value = ['福建锐捷'];
      // 如果业务实体不包含在value中，并且汇率规则为sameDayMiddleRate，则将汇率规则改为poAgreedRate
      if (!value.includes(this.info.bussinessEntity) && this.info.exchangeRateRule === 'sameDayMiddleRate') {
        this.info.exchangeRateRule = 'poAgreedRate';
      }
    }
  },
  computed: {
    exchangeRateRuleOptions: function () {
      let value = ['福建锐捷'];
      if (value.includes(this.info.bussinessEntity)) {
        return [
          { label: '客户付款当日汇率中间价', value: 'sameDayMiddleRate' },
          { label: 'PO 约定汇率', value: 'poAgreedRate' }
        ];
      } else {
        return [
          { label: 'PO 约定汇率', value: 'poAgreedRate' },
          { label: '其他约定汇率', value: 'otherAgreedRate' }
        ];
      }
    }
  }
};
</script>

<style lang="scss">
.messageInput{
  .required{
    color: red;
      margin-left: 3px;
    }
    .uploadPrompt {
      color: red;
    }
    .rj-row-title {
      font-size: 16px;
      font-weight: bold;
      width: 100%;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 10px;
    }

    .related-contract-title {
      clear: both;
      display: block;
    }

    .related-contract-actions {
      display: flex;
      align-items: center;
      width: 100%;
      clear: both;
      margin-bottom: 10px;
    }

    .related-contract-tip {
      margin-left: 12px;
      color: #b2b7c2;
      font-size: 12px;
      line-height: 1;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
  .Related-contract{
    width: 200px;
  }
  .exchange-rate-tip {
    position: absolute;
    font-size: 12px;
    color: #f59e0b;
  }
</style>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.cotractNum_item /deep/ .el-form-item__error {
  position: static;
}
</style>
